"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[94975],{

/***/ 594975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ BlockPromotion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212808);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891004);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47649);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(925810);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(994734);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(862010);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(540415);
/* harmony import */ var _PromotionItem_PromotionItem_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(428487);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledWarningTextRow = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X)`
  padding: 12px 0px;
`;
const BlockPromotion = (_a) => {
  var _b = _a, {
    title,
    description,
    promotions,
    groupType,
    onApplyPromotion,
    onRemovePromotion,
    borderColor = "white",
    backgroundColor = "background",
    warningText,
    productId,
    styledTitle,
    showMore = 1e3,
    styledPromotionItem,
    productSku,
    comboPromotion
  } = _b, props = __objRest(_b, [
    "title",
    "description",
    "promotions",
    "groupType",
    "onApplyPromotion",
    "onRemovePromotion",
    "borderColor",
    "backgroundColor",
    "warningText",
    "productId",
    "styledTitle",
    "showMore",
    "styledPromotionItem",
    "productSku",
    "comboPromotion"
  ]);
  const [showPromotions, setShowPromotions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const isDefaultPromotionBlock = groupType ? groupType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_3__/* .PromotionGroupType.GROUP_TYPE_DEFAULT */ .VM.GROUP_TYPE_DEFAULT : promotions.every((value) => !value.isSelectable);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, __spreadValues({
    borderColor,
    backgroundColor,
    justify: "start",
    borderRadius: "m",
    borderStyle: "solid",
    borderWeight: "m"
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK, __spreadValues({
    level: 4,
    color: "textSecondary"
  }, styledTitle), title, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", {
    style: { fontWeight: "lighter", fontSize: "12px" }
  }, !!description ? ` (${description})` : ``)), showPromotions.map((promotion, index) => {
    const promotionStatus = (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .getPromotionStatus */ .m8)(promotion.cartPromotionId, promotion.isSelectable, groupType);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PromotionItem_PromotionItem_es_js__WEBPACK_IMPORTED_MODULE_6__/* .PromotionItem */ .w, __spreadValues(__spreadValues({
      key: `${promotion.promotionId}-${index}`,
      onApplyPromotion: () => onApplyPromotion == null ? void 0 : onApplyPromotion({
        productId,
        promotionCode: promotion.promotionCode,
        promotionId: promotion.promotionId
      }),
      onRemovePromotion: () => onRemovePromotion == null ? void 0 : onRemovePromotion(promotion.cartPromotionId),
      data: __spreadProps(__spreadValues({}, promotion), { productSku, comboPromotion, promotionStatus })
    }, styledPromotionItem), isDefaultPromotionBlock && promotion.cartPromotionId === null ? { opacity: "m" } : {}));
  }), !!warningText && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledWarningTextRow, {
    padding: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .JX, {
    flex: "8%",
    style: { alignItems: "center", justifyContent: "center" }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .CautionOutlined */ .s, {
    size: 13,
    color: "warning"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .JX, {
    flex: "92%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .YS, {
    level: 1,
    color: "warning"
  }, warningText))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollControlContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZoomOutListButton, {
    setShowList: setShowPromotions,
    originalList: promotions,
    size: showMore
  })));
};
const ZoomOutListButton = ({ setShowList, originalList, size = 2 }) => {
  const [loadMore, setLoadMore] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const [index, setIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const buttonText = loadMore ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_9__.t)("Xem th\xEAm") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_9__.t)("R\xFAt g\u1ECDn");
  const buttonClassName = loadMore ? "att-block-promotion-load-more" : "att-block-promotion-collapse";
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (originalList.length > size) {
      setShowList(originalList.slice(0, size));
      setIndex(size);
    } else {
      setShowList(originalList);
    }
  }, [originalList, size, setShowList]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (size > 0 && originalList.length > size) {
      if (index >= originalList.length) {
        setLoadMore(false);
      } else {
        setLoadMore(true);
      }
    } else {
      setLoadMore(void 0);
    }
  }, [index, originalList.length, size]);
  const load = () => {
    if (index < originalList.length) {
      const newIndex = index + size;
      setShowList(originalList.slice(0, newIndex));
      setIndex(newIndex);
    } else {
      setShowList(originalList.slice(0, size));
      setIndex(size);
    }
  };
  if (loadMore === void 0)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
    width: 80,
    align: "middle",
    marginTop: "s12",
    onClick: load,
    className: buttonClassName
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ClickText, {
    level: 1,
    marginRight: "s4",
    color: "textSecondary"
  }, buttonText), loadMore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .DownOutlined */ .T, {
    color: "textSecondary"
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .UpOutlined */ .X, {
    color: "textSecondary"
  }));
};
const ScrollControlContainer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: inline-block;
  margin: 0 auto;
`;
const ClickText = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT)`
  user-select: none;
`;




/***/ }),

/***/ 428487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ PromotionItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(991822);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(587021);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(883667);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(540415);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(473776);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(446586);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PromotionItem = (_a) => {
  var _b = _a, {
    data,
    isHiddenButton = false,
    hightTitle,
    onApplyPromotion,
    onRemovePromotion
  } = _b, props = __objRest(_b, [
    "data",
    "isHiddenButton",
    "hightTitle",
    "onApplyPromotion",
    "onRemovePromotion"
  ]);
  const {
    promotionStatus,
    cartPromotionId,
    imageUrl,
    title,
    description,
    endedAt,
    promotionId,
    promotionCode,
    comboPromotion,
    productSku,
    highlightedDescriptions
  } = data;
  if (promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.FIXED */ .d.FIXED) {
    return !!title ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, __spreadValues({
      width: "100%"
    }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
      justify: "space-between",
      wrap: false
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
      paddingRight: "s12"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftStyledImage, {
      src: imageUrl,
      width: 16,
      height: 16
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
      width: "100%"
    }, title.split("\n").map((t2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
      level: 1,
      key: t2
    }, t2))))) : null;
  }
  const onClickBtn = () => {
    if (promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackManually */ .gu)("applyCoupon", "orderPromotionPopup", "n/a", comboPromotion ? JSON.stringify({
        comboPromotion,
        sku: productSku,
        promotionId
      }) : JSON.stringify({ promotionId }));
      return onApplyPromotion == null ? void 0 : onApplyPromotion();
    }
    if (promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.SELECTED */ .d.SELECTED && !!cartPromotionId) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackManually */ .gu)("removeCoupon", "orderPromotionPopup", "n/a", comboPromotion ? JSON.stringify({
        comboPromotion,
        sku: productSku,
        promotionId
      }) : JSON.stringify({ promotionId }));
      return onRemovePromotion == null ? void 0 : onRemovePromotion();
    }
  };
  const convertEndedAtTime = (endedAt2) => {
    if (!endedAt2) {
      return "";
    }
    const expiredTime = new Date(endedAt2);
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(expiredTime, "dd/MM/yyyy");
  };
  const borderColor = promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.SELECTED */ .d.SELECTED ? "primary500" : "divider";
  const backgroundColor = promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.SELECTED */ .d.SELECTED ? "primary50" : "white";
  const selectButtonText = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_8__.t)(promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.SELECTED */ .d.SELECTED ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_8__.t)("B\u1ECF ch\u1ECDn") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_8__.t)("\xC1p d\u1EE5ng"));
  const opacity = promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.DISABLED */ .d.DISABLED ? "l" : void 0;
  const disablePromotion = promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.DISABLED */ .d.DISABLED;
  const buttonClassName = promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.SELECTED */ .d.SELECTED ? `unselect-promotion att-unselect-promotion-${promotionId}` : `apply-promotion att-apply-promotion-${promotionId}`;
  const displayPromotionCode = promotionCode ? (promotionCode == null ? void 0 : promotionCode.length) > 12 ? (promotionCode == null ? void 0 : promotionCode.substring(0, 12)) + "..." : promotionCode : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, __spreadValues({
    width: "100%",
    borderStyle: "solid",
    borderRadius: "m",
    borderWeight: "l",
    borderColor,
    backgroundColor,
    padding: "s12",
    opacity
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
    justify: "space-between",
    wrap: false
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
    marginRight: "s12"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageContainer, {
    backgroundColor: imageContainerBGColor(promotionStatus),
    borderRadius: "s"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, {
    src: imageUrl
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
    width: "100%",
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    level: 2,
    line: 2,
    style: { whiteSpace: "pre-line" }
  }, displayPromotionCode ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Tag */ .V, {
    marginRight: "s4",
    content: displayPromotionCode,
    type: "ghost",
    variant: promotionStatus === _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.DISABLED */ .d.DISABLED ? "default" : "branding"
  }) : null, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary",
    line: 2
  }, description), !!(highlightedDescriptions == null ? void 0 : highlightedDescriptions.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Caption */ .YS, {
    level: 1,
    color: "warning"
  }, highlightedDescriptions.join(", "))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
    marginTop: "s8",
    justify: "space-between",
    align: "bottom"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_8__.t)("HSD:"), " ", convertEndedAtTime(endedAt))), !isHiddenButton && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
    variant: "link",
    disabled: disablePromotion,
    onClick: onClickBtn,
    className: buttonClassName
  }, selectButtonText)))));
};
const imageContainerBGColor = (promotionStatus) => {
  switch (promotionStatus) {
    case (_types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.SELECTED */ .d.SELECTED || _types_es_js__WEBPACK_IMPORTED_MODULE_1__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED):
      return "primary100";
    default:
      return "tableHeader";
  }
};
const ImageContainer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"].div`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .CommonStyles */ .F};
  width: 90%;
  min-width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Image */ .E)`
  max-width: 32px;
  max-height: 32px;
`;
const GiftStyledImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Image */ .E)`
  overflow: initial;
`;




/***/ }),

/***/ 862010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ getComboName; },
/* harmony export */   "B1": function() { return /* binding */ getComboImageUrl; },
/* harmony export */   "IH": function() { return /* binding */ getAppliedPromotionsByCartPromotionGroupList; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "cC": function() { return /* binding */ formatPriceFull; },
/* harmony export */   "hJ": function() { return /* binding */ getDateStringWithFormat; },
/* harmony export */   "m8": function() { return /* binding */ getPromotionStatus; },
/* harmony export */   "rb": function() { return /* binding */ PromoItemType; }
/* harmony export */ });
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891004);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883667);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540415);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(473776);





const CURRENCY_CONFIG = {
  VND: {
    locale: "vi-VN",
    currency: "VND"
  },
  GHS: {
    locale: "en-GH",
    currency: "GHS"
  }
};
const formatPrice = (price, numberDisplayFormat) => {
  let formattedPrice = price;
  if (price) {
    formattedPrice = price.toLocaleString("vi-VN");
    if (numberDisplayFormat) {
      const [int, dec = ""] = formattedPrice.split(",");
      const formattedInt = int.replaceAll(".", numberDisplayFormat.thousandSeparator);
      formattedPrice = dec ? `${formattedInt}${numberDisplayFormat.decimalSeparator}${dec}` : formattedInt;
    }
  }
  return formattedPrice;
};
const formatPriceFull = (price, numberDisplayFormat, currency = "VND") => {
  var _a, _b, _c;
  if (price === null || price === void 0 || price === "")
    return price;
  const value = typeof price === "string" ? Number(price) : price;
  const { locale, currency: currencyCode } = CURRENCY_CONFIG[currency];
  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 0
  }).formatToParts(value);
  const integer = parts.filter((p) => p.type === "integer" || p.type === "group").map((p) => p.value).join("").replace(/\D/g, "");
  const fraction = (_a = parts.find((p) => p.type === "fraction")) == null ? void 0 : _a.value;
  let formattedPrice = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (fraction) {
    formattedPrice += `,${fraction}`;
  }
  const currencySymbol = (_c = (_b = parts.find((p) => p.type === "currency")) == null ? void 0 : _b.value) != null ? _c : "";
  formattedPrice = `${formattedPrice}${currencySymbol}`;
  if (numberDisplayFormat) {
    const [int, dec = ""] = formattedPrice.split(",");
    const formattedInt = int.replaceAll(".", numberDisplayFormat.thousandSeparator);
    formattedPrice = dec ? `${formattedInt}${numberDisplayFormat.decimalSeparator}${dec}` : formattedInt;
  }
  return formattedPrice;
};
const sortItems = (childItems) => {
  return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
  if (childItems.length === 0)
    return "";
  const primary = sortItems(childItems)[0];
  const comboLength = childItems.length;
  return comboLength === 1 ? primary.name : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("{{PrimaryName}} v\xE0 {{var0}} s\u1EA3n ph\u1EA9m kh\xE1c", {
    PrimaryName: primary.name,
    var0: comboLength - 1
  });
};
const getComboImageUrl = (childItems) => {
  if (childItems.length === 0)
    return [];
  return sortItems(childItems).map((item) => {
    var _a, _b;
    return item.imageUrl || ((_b = (_a = item.product) == null ? void 0 : _a.productInfo) == null ? void 0 : _b.imageUrl);
  });
};
const getDateStringWithFormat = (dateString, format = "HH:mm dd/MM/yyyy") => {
  try {
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(dateString), format);
  } catch (e) {
    return "";
  }
};
var PromoItemType = /* @__PURE__ */ ((PromoItemType2) => {
  PromoItemType2["GIFT"] = "gift";
  PromoItemType2["DISCOUNT"] = "discount";
  PromoItemType2["VOUCHER"] = "voucher";
  return PromoItemType2;
})(PromoItemType || {});
const getAppliedPromotionsByCartPromotionGroupList = (cartPromotionGroupList) => {
  const gifts = [];
  cartPromotionGroupList.forEach((blockPromotion) => {
    blockPromotion.promotions.forEach((promotion) => {
      if (promotion.cartPromotionId !== null) {
        gifts.push({
          imageUrl: promotion.imageUrl,
          name: promotion.title
        });
      }
    });
  });
  return gifts;
};
const getPromotionStatus = (cartPromotionId, isSelectable, groupType) => {
  if (groupType) {
    if (groupType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_2__/* .PromotionGroupType.GROUP_TYPE_DEFAULT */ .VM.GROUP_TYPE_DEFAULT) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.FIXED */ .d.FIXED;
    } else {
      if (!isSelectable) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.DISABLED */ .d.DISABLED;
      } else if (cartPromotionId === null) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
      } else if (cartPromotionId !== null) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.SELECTED */ .d.SELECTED;
      }
    }
  } else {
    if (cartPromotionId === null && isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
    } else if (cartPromotionId === null && !isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.DISABLED */ .d.DISABLED;
    } else if (cartPromotionId !== null && isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.SELECTED */ .d.SELECTED;
    } else {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.FIXED */ .d.FIXED;
    }
  }
};




/***/ }),

/***/ 540415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/vi.es.js
var viLang = {
	
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/en.es.js
var enLang = {
	"Được phép nâng giá bán tối đa": "Max raised price allowed",
	"Giá muốn bán không được vượt quá {{var0}}": "Selling price cannot exceed {{var0}}",
	"Giá muốn bán không được nhỏ hơn giá sản phẩm": "Selling price cannot be less than supplier price",
	"Giá sản phẩm": "Supplier price",
	"Giá muốn bán": "Selling price",
	"Nhập số tiền": "Input amount",
	"Số tiền chênh:": "Gap amount:",
	"Sửa giá": "Edit price",
	"Dùng sau": "Use later",
	"Áp dụng": "Apply",
	"Bỏ chọn": "Unselect",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Bạn chỉ có thể mua tối đa {{maximumValue}} sản phẩm": "You can only purchase max {{maximumValue}} products",
	"Chú ý": "Note",
	"Bạn muốn xoá sản phẩm này ra khỏi giỏ hàng?": "Are your sure to delete product from Cart?",
	"Đồng ý": "Agree",
	"Hủy bỏ": "Cancel",
	"Xóa": "Delete",
	"x{{ProductVoucherQuantity}} Voucher dùng cho đơn hàng sau": "x{{ProductVoucherQuantity}} Voucher used for next order",
	"Không bán chịu": "Not selling on credit",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Chỉ áp dụng trên một số sản phẩm": "Applicable for some specific products only",
	"Giảm": "Discount",
	"tối đa {{maxAmount}}": "max {{maxAmount}}",
	"Dành": "Applicable",
	"cho đơn hàng từ {{min}} đến {{max}}": "for the order from {{min}} to {{max}}",
	"cho đơn hàng tối thiểu {{min}}": "for the order from {{min}}",
	"cho đơn hàng dưới {{max}}": "for the order under {{max}}",
	"cho tất cả các đơn hàng": "for all orders",
	"Giảm {{percent}}% tối đa {{maxAmount}}": "{{percent}}% off up to {{maxAmount}}",
	"{{quantity}}x {{name}} Mã giảm giá cho đơn hàng sau": "{{quantity}}x {{name}} Discount code for next order",
	"Thành tiền": "Total",
	"Đơn giá": "Unit price",
	"Số lượng": "Quantity",
	"Khuyến mại hot": "Promotions hot",
	"HSD:": "Expiry date:",
	"Chương trình khuyến mại": "Promotions",
	"Sản phẩm ưu đãi": "Promotional products",
	"Tìm kiếm chương trình khuyến mại": "Search promotions",
	"Xem thêm": "Show more",
	"Rút gọn": "Collapse",
	"Tìm kiếm sản phẩm khuyến mại": "Search promotional products",
	"Không tìm thấy chương trình nào.": "No program found.",
	"Không tìm thấy sản phẩm nào.": "No product found.",
	"Lỗi": "Error"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ui-cart";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 473776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PromotionStatus; }
/* harmony export */ });
var PromotionStatus = /* @__PURE__ */ ((PromotionStatus2) => {
  PromotionStatus2[PromotionStatus2["SELECTED"] = 0] = "SELECTED";
  PromotionStatus2[PromotionStatus2["UNSELECTED"] = 1] = "UNSELECTED";
  PromotionStatus2[PromotionStatus2["DISABLED"] = 2] = "DISABLED";
  PromotionStatus2[PromotionStatus2["FIXED"] = 3] = "FIXED";
  return PromotionStatus2;
})(PromotionStatus || {});




/***/ })

}]);